import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import user from './user';
import esign from './esign'
import loader from './loader';
import proof from './proof';
import personalInfo from './personalInfo';
import scheme from './scheme';
import payment from './payment';
import auRmDetails from './auRmDetails';
import homePageQueryParams from './homePageQueryParams';
import responseError from './responseError'
import history from '../../lib/history';
import { enableES5 } from 'immer';
import nominee from './nominee'
import feedback from './feedback'
import bank from './bank';
import journey from './journey';
import { APP_RESET } from '../types/app';

enableES5();
let historyR = !process.env.IS_SERVER ? { router: connectRouter(history) } : {};

const appReducer = combineReducers({
  ...historyR,
  user,
  esign,
  proof,
  personalInfo,
  loader,
  scheme,
  payment,
  auRmDetails,
  homePageQueryParams,
  responseError,
  nominee,
  feedback,
  bank,
  journey,
})

// Exit Journey resets every slice to its initialState (each reducer re-inits
// from `undefined`), but the router slice is preserved so the in-flight
// redirect/history isn't torn down. See APP_RESET / resetJourneyState.
const rootReducer = (state, action) => {
  if (action.type === APP_RESET) {
    const preserved = state && state.router ? { router: state.router } : undefined;
    return appReducer(preserved, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
